import { j as e } from '../../../_virtual/jsx-runtime.js';
import { TextLink as c } from '../TextLink/TextLink.js';
const a = {
    base: 'w-full bg-footer-bg p-space-500 flex flex-col',
    contentSpacing:
      'mx-auto grid justify-items-start tablet:justify-items-center-safe gap-6 grid-cols-12 w-10/12 tablet:w-9/12 desktop:max-w-container',
    linksList:
      'col-span-12 flex flex-col gap-space-400 tablet:gap-space-500 justify-start tablet:flex-row flex-wrap tablet:justify-center',
  },
  p = ({
    clientName: t,
    links: s = [
      { text: 'Appliance care service plan terms and conditions', href: '#' },
      { text: `${t} Product Support`, href: '#' },
      { text: 'Terms of Use', href: '#' },
      { text: 'Domestic & General privacy notice', href: '#' },
      { text: `${t} privacy notice`, href: '#' },
      { text: 'Cookies notice', href: '#' },
    ],
    addendum: l = '',
  }) =>
    /* @__PURE__ */ e.jsx('footer', {
      className: a.base,
      children: /* @__PURE__ */ e.jsxs('div', {
        className: `${a.contentSpacing}`,
        children: [
          s &&
            s.length > 0 &&
            /* @__PURE__ */ e.jsx('nav', {
              className: `${a.linksList}`,
              children: s.map((r, i) =>
                /* @__PURE__ */ e.jsx(
                  'div',
                  { children: /* @__PURE__ */ e.jsx(c, { href: r.href, children: r.text }) },
                  i,
                ),
              ),
            }),
          /* @__PURE__ */ e.jsxs('article', {
            className: 'text-left col-span-12',
            children: [
              /* @__PURE__ */ e.jsxs('p', {
                className: 'text-body-small',
                children: [
                  t,
                  ' Appliance Care service plans are provided by Domestic & General USA Services LLC. However, in Florida and Washington it is Domestic & General USA Inc. 866-333-3134, 230 East Avenue, Norwalk, CT, 06855. ',
                  l,
                ],
              }),
              /* @__PURE__ */ e.jsx('br', {}),
              /* @__PURE__ */ e.jsx('p', {
                className: 'text-body-small',
                children:
                  'This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.',
              }),
              /* @__PURE__ */ e.jsx('br', {}),
              /* @__PURE__ */ e.jsxs('p', {
                className: 'text-body-small',
                children: [
                  ' ',
                  '© ',
                  /* @__PURE__ */ new Date().getFullYear(),
                  ' Domestic & General USA IP LLC',
                  ' ',
                ],
              }),
            ],
          }),
        ],
      }),
    });
export { p as Footer };
